import React from 'react';
import { Link2Off, AlertTriangle } from 'lucide-mui';

export type ErrorType =
  | 'recordingRequestExpired'
  | 'sharedConentNotFound'
  | 'default';
interface ErrorData {
  errorCode: number;
  errorTitle: string;
  errorDescription: string;
  getIcon: () => React.ReactChild;
}
export const errors: {
  [key in ErrorType]: ErrorData;
} = {
  recordingRequestExpired: {
    errorCode: 4000,
    errorTitle: 'Record invitation link has been expired',
    errorDescription: 'Please ask the host to send you a new link',
    getIcon: () => <Link2Off fontSize="inherit" />,
  },
  sharedConentNotFound: {
    errorCode: 4004,
    errorTitle: `"Uh-oh! We can't find your video"`,
    errorDescription: `The video you are trying to view has been removed from ScreenApp
      or the owner of the video has not granted you viewing rights.`,
    getIcon: () => <AlertTriangle fontSize="inherit" />,
  },
  default: {
    errorCode: 5000,
    errorTitle: 'Something went wrong',
    errorDescription: 'Please try again later',
    getIcon: () => <AlertTriangle fontSize="inherit" />,
  },
};

// Using type assertion to tell TypeScript the specific type
export const errorTypes = Object.keys(errors) as ErrorType[];
